import { Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { useState } from "react";
import { ECOSYSTEM_DATA } from "../landingConstants";
import { Section, Title } from "../utils";
import ButtonGroup from "./ButtonGroup";
import ConditionalMarquee from "./ConditionalMarquee";

const ImgCard = ({ imgPath, title }: { imgPath: string; title: string }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Flex
      flexDir="column"
      gap="4px"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      alignItems="center"
      pt={{ base: "16px", md: "32px" }}
      px={{ base: 1, md: 3 }}
    >
      <Box
        transform={isHovered ? "scale(1.25)" : "scale(1)"}
        transition="all 0.3s ease"
        transformOrigin="bottom"
      >
        <Box
          height={{ base: "64px", md: "128px" }}
          width={{ base: "64px", md: "128px" }}
        >
          <BaseImage src={imgPath} alt={title} fill />
        </Box>
      </Box>
      <Text
        visibility={isHovered ? "visible" : "hidden"}
        transition="all 0.3s ease"
        fontSize={{ base: "12px", md: "16px" }}
        fontWeight="500"
        lineHeight={{ base: "14px", md: "22px" }}
        color="textSecondary"
        mt="2px"
      >
        {title}
      </Text>
    </Flex>
  );
};

const Ecosystem = () => {
  const tabs = Object.keys(ECOSYSTEM_DATA);
  const [selected, setSelected] = useState(tabs[0]);

  const buttons = tabs.map((data) => {
    return {
      key: data,
      title: ECOSYSTEM_DATA[data].title,
    };
  });

  return (
    <Section>
      <SimpleGrid
        alignItems="center"
        justifyContent="space-between"
        columns={{ sm: 1, md: 2 }}
        spacing={{ base: "24px", md: 0 }}
      >
        <Title>
          Ecosystem <br /> Partners
        </Title>
        <ButtonGroup
          selected={selected}
          buttons={buttons}
          onSelect={(key: string) => setSelected(key)}
        />
      </SimpleGrid>

      <ConditionalMarquee>
        <Flex alignItems="center">
          {ECOSYSTEM_DATA[selected].data.map((data) => {
            return (
              <ImgCard
                title={data.title}
                imgPath={data.imgUrl}
                key={data.title}
              />
            );
          })}
        </Flex>
      </ConditionalMarquee>
    </Section>
  );
};

export default Ecosystem;
